export default class SolutionSection {
    static init(): void {
        const solutionSection = document.querySelector('.js-solution-section') as HTMLElement;
        if (!solutionSection) return;

        const solutionTriggers = solutionSection.querySelectorAll('.solution-trigger') as NodeListOf<HTMLElement>;
        const solutionContents = solutionSection.querySelectorAll('.solution-content') as NodeListOf<HTMLElement>;

        // Funkce pro zjištění šířky okna
        function isMobile(): boolean {
            return window.innerWidth <= 991;
        }

        // Funkce pro aktivaci obsahu
        function activateContent(targetId: string | null): void {
            if (!targetId) return;

            // Odebereme is-active ze všech triggerů a obsahů
            solutionTriggers.forEach((trigger) => trigger.classList.remove('is-active'));
            solutionContents.forEach((content) => content.classList.remove('is-active'));

            // Přidáme is-active k příslušnému triggeru a obsahu
            const activeTrigger = solutionSection.querySelector(`[data-solution-trigger="${targetId}"]`) as HTMLElement;
            const activeContent = solutionSection.querySelector(`[data-solution-content="${targetId}"]`) as HTMLElement;

            if (activeTrigger) activeTrigger.classList.add('is-active');
            if (activeContent) activeContent.classList.add('is-active');
        }

        // Event handlery pro každý trigger
        solutionTriggers.forEach((trigger) => {
            const targetId = trigger.getAttribute('data-solution-trigger');

            // Click handler pro mobily
            trigger.addEventListener('click', function (e: Event): void {
                e.preventDefault();
                if (isMobile()) {
                    activateContent(targetId);
                }
            });

            // Hover handler pro desktop
            trigger.addEventListener('mouseenter', function (): void {
                if (!isMobile()) {
                    activateContent(targetId);
                }
            });
        });
    }
}
